import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

export const stateTransitionsReducer = (state = initialState.document.stateTransitions, action) => {
  switch (action.type) {
    case actionTypes.LOAD_STATE_TRANSITIONS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true,
          loaded: false
        }
      };
    }
    case actionTypes.LOAD_STATE_TRANSITIONS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }
    case eventTypes.STATE_TRANSITION_CHANGED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: false
        }
      };
    }

    default:
      return state;
  }
};
